/**
 * Build a public S3 URL for a theme asset filename.
 * Passes through values that are already absolute URLs.
 */
export function s3PublicUrl(asset) {
  if (asset == null || asset === "") return "";
  const s = String(asset).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const base = process.env.REACT_APP_S3_PATH || "";
  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  return normalizedBase + s.replace(/^\/+/, "");
}
